import { GET_ALL_GROUPS } from "../graphql/queries/getAllGroups"
import { useQuery } from "@apollo/client"

export const useAllGroups = (
  first?: number,
  skip?: number,
  search?: string,
  orderBy?: string,
  orgIds?: Array<number | string>,
) => {
  const { data, error, loading, refetch } = useQuery(GET_ALL_GROUPS, {
    variables: {
      first: first,
      skip: skip,
      search: search,
      orderBy: orderBy,
      orgIds: orgIds,
    },
  })
  return {
    allGroups: data?.allGroups,
    error,
    isLoading: loading,
    refetch,
  }
}
